import React from 'react';
import { getPartnerAccent } from '../../themes/partnerTheme';
import { getBcmLabels } from '../../scenes/Dashboard/scenes/Plan/planSections';
import './Progress.scss';

const PROCESS = {
  risk_analysis: { name: 'Risk Analysis', color: getPartnerAccent('risk') },
  policy_programme: { name: 'Program', color: getPartnerAccent('program') },
  analysis_planning: { name: 'Analysis', color: getPartnerAccent('analysis') },
  planning_design: { name: 'Design', color: getPartnerAccent('design') },
  implementation: { name: 'Implementation', color: getPartnerAccent('implementation') },
  validation: { name: 'Validation', color: getPartnerAccent('validation') },
};

function ProgressBar({ color, title, progress }) {
  return (
    <div className="plan-progress-item">
      <div className="plan-progress-item__track" aria-hidden>
        <div
          className="plan-progress-item__fill"
          style={{ width: `${progress}%`, backgroundColor: color }}
        />
      </div>
      <div className="plan-progress-item__pct" style={{ color }}>
        {progress}%
      </div>
      <div className="plan-progress-item__legend">
        <span className="plan-progress-item__dot" style={{ backgroundColor: color }} aria-hidden />
        <span className="plan-progress-item__name">{title}</span>
      </div>
    </div>
  );
}

function Progress({ progress = {}, variant = 'default' }) {
  const isAvivaVariant = variant === 'aviva';
  const bcmLabels = getBcmLabels(variant);
  const labelOverrides = isAvivaVariant
    ? {
        policy_programme: bcmLabels.program,
        analysis_planning: bcmLabels.analysis,
        planning_design: bcmLabels.design,
        implementation: bcmLabels.implementation,
        validation: bcmLabels.validation,
      }
    : {};

  const order = isAvivaVariant
    ? ['policy_programme', 'analysis_planning', 'planning_design', 'implementation', 'validation', 'risk_analysis']
    : Object.keys(PROCESS);

  const progressList = [];
  order.forEach((key) => {
    if (key in progress) {
      const { name, color } = PROCESS[key];
      progressList.push({
        key,
        name: labelOverrides[key] || name,
        color,
        progress: Math.min((progress[key] * 100).toFixed(0), 100),
      });
    }
  });

  if (!progressList.length) return null;

  return (
    <div className="widget plan-progress">
      <div className="plan-progress__bars">
        {progressList.map((data) => (
          <ProgressBar key={data.key} title={data.name} color={data.color} progress={data.progress} />
        ))}
      </div>
      <div className="plan-progress__footer" role="presentation">
        {progressList.map((data) => (
          <div key={data.key} className="plan-progress-footer-col">
            <div className="plan-progress-footer-col__label" style={{ color: data.color }}>
              {data.name}
            </div>
            <div className="plan-progress-footer-col__pct" style={{ color: data.color }}>
              {data.progress}%
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Progress;
